import * as React from 'react'
import {
  DsGrow,
  DsImage,
  DsStack,
  DsStackProps,
  DsTypography
} from '@am92/react-design-system'

import { DynamicString } from '~/src/Components/DynamicString'

import { T_LANDING_PAGE_CONSTANTS } from '../../Landing.PageConstants/TYPES'
import {
  FEATURE_IMAGE_MAP,
  FEATURE_TEXT_KEY_MAP,
  T_FEATURES
} from '../../LandingPage.Constants'

import { T_DYNAMIC_STRING } from '~/src/Types/StaticPage.Types'

export interface IFeatureCardProps {
  PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS
  index: number
  feature: T_FEATURES
}

export function FeatureCard(props: IFeatureCardProps) {
  const { index, feature, PAGE_CONSTANTS } = props

  let stackDirection: DsStackProps['direction'] = {
    xs: 'column-reverse',
    md: 'row-reverse'
  }

  if (index % 2 === 0) {
    stackDirection = { xs: 'column-reverse', md: 'row' }
  }

  const imgSrcset = FEATURE_IMAGE_MAP[feature]
  const { title: titlePath, description: descriptionPath } =
    FEATURE_TEXT_KEY_MAP[feature]
  const title = PAGE_CONSTANTS[titlePath] as T_DYNAMIC_STRING[]
  const description = PAGE_CONSTANTS[descriptionPath] as string

  return (
    <DsGrow in timeout={{ enter: 500 }}>
      <DsStack
        direction={stackDirection}
        sx={{
          p: 'var(--ds-spacing-quickFreeze)',
          backgroundColor: 'var(--ds-colour-surfaceSecondary)',
          borderRadius: 'var(--ds-radius-bitterCold)'
        }}
      >
        <DsStack
          flex={1}
          justifyContent='center'
          spacing='var(--ds-spacing-glacial)'
          sx={{
            px: {
              xs: 'var(--ds-spacing-cool)',
              md: 'var(--ds-spacing-tropical)'
            },
            py: {
              xs: 'var(--ds-spacing-cool)',
              md: 'var(--ds-spacing-tropical)'
            }
          }}
        >
          <DynamicString dynamicString={title} />

          <DsTypography
            variant='bodyRegularLarge'
            color='text.secondary'
            textAlign={{ xs: 'center', md: 'left' }}
            sx={{ width: { xs: '100%', md: '75%' } }}
          >
            {description}
          </DsTypography>
        </DsStack>
        <DsStack
          flex={1}
          justifyContent='center'
          alignItems='center'
          sx={{
            backgroundColor: 'var(--ds-colour-surfaceBackground)',
            borderRadius: 'var(--ds-radius-bitterCold)'
          }}
        >
          <DsImage srcSet={imgSrcset} aspectRatio={580 / 290} loading='lazy' />
        </DsStack>
      </DsStack>
    </DsGrow>
  )
}
